<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    tag?: string | Component;
    vertical?: "top" | "bottom";
    horizontal?: "start" | "end";
  }>(),
  {
    tag: "div",
    vertical: "top",
    horizontal: "start",
  }
);

provide(
  "vertical",
  computed(() => props.vertical)
);

provide(
  "horizontal",
  computed(() => props.horizontal)
);

const classes = computed(() => [
  "app-map-actions",
  "absolute p-5",
  "flex flex-col gap-2.5",
  {
    "app-map-actions--top top-0": props.vertical === "top",
    "app-map-actions--bottom bottom-0": props.vertical === "bottom",
    "app-map-actions--start start-0": props.horizontal === "start",
    "app-map-actions--end end-0": props.horizontal === "end",
  },
]);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
